import lottie from 'lottie-web/build/player/lottie_light.min';

// makes lottie api available from this.$lottie in a nuxt application
export default ({ app }, inject) => {
  inject('lottie', lottie);
};
